import React from 'react';
import PropTypes from 'prop-types';

const ListIcon = ({ color = "#64748B", size }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ minWidth: 20 }}>
        <path d="M5.66406 4.25H14.8724" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5.66406 8.5H14.8724" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5.66406 12.75H14.8724" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2.125 4.25H2.1325" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2.125 8.5H2.1325" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M2.125 12.75H2.1325" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

ListIcon.propTypes = {
    color: PropTypes.string,
    size: PropTypes.string,
};

ListIcon.defaultProps = {
    color: 'currentColor',
    size: '30px',
};

export default ListIcon;
